var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.76 92.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.83A102.22,102.22,0,0,1,31.56,1.17,102.91,102.91,0,0,1,55,.29,3.6,3.6,0,0,1,56.74,1a3.13,3.13,0,0,0-.76.28C47.64,7,43.53,14.89,43.28,25A20.87,20.87,0,0,1,26.36,45.41c-9.29,1.91-19.6-2.93-23-11.75C1.54,28.77,1.33,23.25.39,18,.24,17.2.13,16.39,0,15.58Zm93.76,3.33c-.55,4-1,8-1.66,11.91a97.46,97.46,0,0,1-16,38.47,9.52,9.52,0,0,1-.68.83,81.48,81.48,0,0,0-2.26-9A27.54,27.54,0,0,0,61,43.05,20.86,20.86,0,0,1,50.85,20.72,20.69,20.69,0,0,1,68,4.13a17.66,17.66,0,0,1,8.37.5C82.25,6.69,88,9.39,93.76,11.83Zm-85,34.37c7.14,3.58,14.21,4.51,21.52,2.26a35.49,35.49,0,0,0,6.27-2.72A21,21,0,0,1,65.33,77.39a13.8,13.8,0,0,1-3.17,4c-4.22,3.48-8.6,6.77-12.93,10.12a3.64,3.64,0,0,1-4.61.08A98.32,98.32,0,0,1,9,50.48C9,50.31,8.91,50.11,8.72,49.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXem);
export default __webpack_public_path__ + "static/media/xem.5a0bc24b378d5e39289c87a659513612.svg";
export { ForwardRef as ReactComponent };